<template>
  <v-card class="my-4" outlined>
    <v-card-text class="px-0">
      <v-simple-table dense>
        <thead>
          <tr>
            <th colspan="10" class="px-0 text-center text-body-1 font-weight-bold">
              Las inscripciones del programa que cumplen con los requisitos para ser reportados pero no están inscritos
              en el programa de universidad vinculado se muestran a continuación.
            </th>
          </tr>

          <tr>
            <th colspan="10" class="px-0 text-center text-body-2">
              Requisitos para ser reportados: Estado de Inscripción
              <v-chip dark small :color="coloresEstadosInscripcion[1]">Inscrito</v-chip>, Estado de Cartera
              <v-chip dark small :color="coloresEstadosCartera['Exento de deuda']"> Exento de deuda </v-chip>
              o <v-chip dark small :color="coloresEstadosCartera['Vigente']">Vigente</v-chip>, Estado Administrativo
              <v-chip dark small :color="coloresEstadosAdministrativos['Inscrito']"> Inscrito </v-chip>
              y Estado Académico
              <v-chip dark small :color="coloresEstadosAcademicos['En Desarrollo']"> En Desarrollo </v-chip>,
              <v-chip dark small :color="coloresEstadosAcademicos['En Desarrollo - Nivelacion']">
                En Desarrollo - Nivelacion
              </v-chip>
              o
              <v-chip dark small :color="coloresEstadosAcademicos['Concluido Aprobado']"> Concluido Aprobado </v-chip>
            </th>
          </tr>

          <tr>
            <th style="min-width: 30px">#</th>
            <th style="min-width: 120px">ID Inscripción</th>
            <th style="min-width: 220px">Estado Actual</th>
            <th style="min-width: 220px">Estado Cartera</th>
            <th style="min-width: 220px">Estado Administrativo</th>
            <th style="min-width: 220px">Estado Académico</th>
            <th style="min-width: 140px">N° Documento</th>
            <th style="min-width: 300px">Nombre Completo Participante</th>
            <th style="min-width: 120px">ID Programa</th>
            <th style="min-width: 450px">Programa</th>
            <th style="min-width: 200px">Sede</th>
          </tr>
        </thead>

        <tbody>
          <tr v-if="inscripcionesProgramaCumplenRequisitosNoInscritosEnProgramaUniversidad.length === 0">
            <td colspan="11" class="text-center">No hay inscripciones para mostrar en este programa.</td>
          </tr>

          <tr v-if="inscripcionesProgramaCumplenRequisitosNoInscritosEnProgramaUniversidad.length === 0">
            <td colspan="11" class="text-center">
              No hay inscripciones que cumplan requisitos para ser reportados pero no estén inscritos en el programa de
              universidad vinculado.
            </td>
          </tr>

          <tr v-if="inscripcionesProgramaCumplenRequisitosNoInscritosEnProgramaUniversidad.length > 0">
            <td colspan="11" class="px-0">
              <v-alert class="mb-0 text-center" type="warning" dense text>
                Inscripciones del programa que cumplen requisitos para ser reportados pero no están inscritos en el
                programa de universidad vinculado
              </v-alert>
            </td>
          </tr>

          <tr
            v-for="(
              inscripcionPrograma, index
            ) in inscripcionesProgramaCumplenRequisitosNoInscritosEnProgramaUniversidad"
            :key="inscripcionPrograma.id">
            <td>{{ index + 1 }}</td>
            <td>{{ inscripcionPrograma.id }}</td>
            <td class="text-center">
              <v-chip :color="coloresEstadosInscripcion[inscripcionPrograma.estadoInscripcion]" dark small>
                {{ estadosInscripcion[inscripcionPrograma.estadoInscripcion] }}
              </v-chip>
            </td>
            <td class="text-center">
              <v-chip
                v-if="inscripcionPrograma.estadoCartera?.nombre"
                :color="coloresEstadosCartera[inscripcionPrograma.estadoCartera.nombre]"
                dark
                small>
                {{ inscripcionPrograma.estadoCartera.nombre }}
              </v-chip>

              <span v-else>-</span>
            </td>
            <td class="text-center">
              <v-chip
                v-if="inscripcionPrograma.estadoAdministrativo?.nombre"
                :color="coloresEstadosAdministrativos[inscripcionPrograma.estadoAdministrativo.nombre]"
                dark
                small>
                {{ inscripcionPrograma.estadoAdministrativo.nombre }}
              </v-chip>

              <span v-else>-</span>
            </td>
            <td class="text-center">
              <v-chip
                v-if="inscripcionPrograma.estadoAcademico"
                :color="coloresEstadosAcademicos[inscripcionPrograma.estadoAcademico]"
                dark
                small>
                {{ inscripcionPrograma.estadoAcademico }}
              </v-chip>

              <span v-else>-</span>
            </td>
            <td>{{ inscripcionPrograma.estudiante.numeroDocumento }}</td>
            <td>
              {{
                concatenar(
                  inscripcionPrograma.estudiante.primerApellido,
                  inscripcionPrograma.estudiante.segundoApellido,
                  inscripcionPrograma.estudiante.nombres,
                )
              }}
            </td>
            <td>{{ inscripcionPrograma.programa.id }}</td>
            <td class="text-truncate">{{ inscripcionPrograma.programa.nombreCompuesto }}</td>
            <td class="text-truncate">{{ inscripcionPrograma.programa.sede.nombre }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  COLORES_ESTADOS_ACADEMICOS,
  COLORES_ESTADOS_ADMINISTRATIVOS,
  COLORES_ESTADOS_CARTERA,
  COLORES_ESTADOS_INSCRIPCION,
  ESTADOS_INSCRIPCION,
} from '../utils/constantes';
export default {
  name: 'TablaInscripcionesPrograma',
  props: {
    inscripcionesProgramaCumplenRequisitosNoInscritosEnProgramaUniversidad: {
      type: Array,
      required: true,
    },
  },
  computed: {},
  data() {
    return {
      estadosInscripcion: ESTADOS_INSCRIPCION,
      coloresEstadosInscripcion: COLORES_ESTADOS_INSCRIPCION,
      coloresEstadosCartera: COLORES_ESTADOS_CARTERA,
      coloresEstadosAdministrativos: COLORES_ESTADOS_ADMINISTRATIVOS,
      coloresEstadosAcademicos: COLORES_ESTADOS_ACADEMICOS,
    };
  },
  methods: {
    concatenar(...args) {
      return args.filter((arg) => arg).join(' ');
    },
  },
};
</script>